import { useEffect } from "react";
import { ShortcutBinding } from "../shortcuts/ShortcutManager";
import { useDesktopKeyboardContext } from "../context/DesktopKeyboardContext";

export function useRegisterShortcuts(bindings: ShortcutBinding[] = []) {
  const { desktop, shortcuts } = useDesktopKeyboardContext();

  useEffect(() => {
    if (!desktop.isDesktop || !shortcuts || bindings.length === 0) return undefined;
    const disposers = bindings.map((binding) => shortcuts.register(binding));
    return () => disposers.forEach((dispose) => dispose());
  }, [desktop.isDesktop, shortcuts, bindings]);
}
